import React, { Suspense, lazy } from 'react';
import PropTypes from 'prop-types';
import { Page } from '@edreamsodigeo/frontend-core';
import { InvoicesFunnel } from '../funnels/Invoices';
import { FlightsResultsFunnel } from '../funnels/FlightResults';
import { SemResultsFunnel } from '../funnels/SemResults';
import { flightsPaymentPrimeProviderProps } from '../pages/Payment/integrationOf1';
import Container from './Container';
import { CancellationFunnel } from '../funnels/Cancellation';
import { ModificationLCFunnel } from '../funnels/Modification';
import { AlternativesFunnel } from '../funnels/Alternatives';
import TripSummary from '../pages/TripSummary';
import { AuthenticationFunnel } from '../funnels/Authentication';
import MytripsLogin from '../pages/MytripsLogin';
import { MembershipPagesFunnel } from '../funnels/MembershipPages';
import { ProfileFunnel } from '../funnels/ProfilePages';
import { DetailsLoadingPage } from '../pages/Waitings';
import { mmbHandlers } from '../boundaries/mmb';
import AncillariesPages from '../pages/Ancillaries';
const FareRulesPage = /*#__PURE__*/lazy(() => import('../pages/FareRules'));
const DetailsPage = /*#__PURE__*/lazy(() => import('../pages/Details'));
const PassengerInfoPage = /*#__PURE__*/lazy(() => import('../pages/PassengerInfo'));
const PaymentPage = /*#__PURE__*/lazy(() => import('../pages/Payment'));
const MembershipMobilePage = /*#__PURE__*/lazy(() => import('../pages/MembershipRouter'));
const FlightInfoPage = /*#__PURE__*/lazy(() => import('../pages/FlightInfo'));
const DynpackAccommodationResultsPage = /*#__PURE__*/lazy(() => import('../pages/DynpackAccommodationResults'));
const DynpackFlightsResultsPage = /*#__PURE__*/lazy(() => import('../pages/DynpackFlightsResults'));
const DynpackAccommodationDetailsPage = /*#__PURE__*/lazy(() => import('../pages/DynpackAccommodationDetails'));
const DynpackTripSummaryPage = /*#__PURE__*/lazy(() => import('../pages/DynpackTripSummary'));
const RefundStatusPage = /*#__PURE__*/lazy(() => import('../pages/RefundStatusPage'));
const BookingStatusSummary = /*#__PURE__*/lazy(() => import('../pages/BookingStatusSummary'));
const TripDetailsPage = /*#__PURE__*/lazy(() => import('../pages/TripDetails'));
const UnavailableCheckin = /*#__PURE__*/lazy(() => import('../pages/UnavailableCheckin'));
const PaymentMethods = /*#__PURE__*/lazy(() => import('../pages/PaymentMethods'));
const MyTripsPage = /*#__PURE__*/lazy(() => import('../pages/MyTrips'));
const App = ({
  flightResultsProps
}) => /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Page, {
  path: "refundstatusOF2"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(RefundStatusPage, null))), /*#__PURE__*/React.createElement(FlightsResultsFunnel, flightResultsProps), /*#__PURE__*/React.createElement(SemResultsFunnel, flightResultsProps), /*#__PURE__*/React.createElement(Page, {
  path: "dpresults_accommodation"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(DynpackAccommodationResultsPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "dpresults_flights"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(DynpackFlightsResultsPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "dpresults_accommodation_details"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(DynpackAccommodationDetailsPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "accommodation_details"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(DynpackAccommodationDetailsPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "dpresults_trips_summary"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(DynpackTripSummaryPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "fare-rules"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(FareRulesPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "details"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(DetailsPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "passengersinfo"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(PassengerInfoPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "payment"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(PaymentPage, {
  primePropsFromOF1: flightsPaymentPrimeProviderProps
}))), /*#__PURE__*/React.createElement(Page, {
  path: "flightinfo"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(FlightInfoPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "flightsummary"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(TripSummary, null))), /*#__PURE__*/React.createElement(Page, {
  path: "membership"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(MembershipMobilePage, null))), /*#__PURE__*/React.createElement(AuthenticationFunnel, null), /*#__PURE__*/React.createElement(Page, {
  path: "tripdetails"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(TripDetailsPage, {
  mmbHandlers: mmbHandlers
}))), /*#__PURE__*/React.createElement(Page, {
  path: "unavailablecheckin"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(UnavailableCheckin, null))), /*#__PURE__*/React.createElement(Page, {
  path: "tripdetails_booking_status"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(BookingStatusSummary, null))), /*#__PURE__*/React.createElement(Page, {
  path: "mytripslogin"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(MytripsLogin, null))), /*#__PURE__*/React.createElement(Page, {
  path: "mytrips"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(MyTripsPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "detailsloading"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(DetailsLoadingPage, null))), /*#__PURE__*/React.createElement(Page, {
  path: "accountcreditcards"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(PaymentMethods, null))), /*#__PURE__*/React.createElement(Page, {
  path: "ancillaries"
}, /*#__PURE__*/React.createElement(Suspense, {
  fallback: null
}, /*#__PURE__*/React.createElement(AncillariesPages, null))), /*#__PURE__*/React.createElement(InvoicesFunnel, null), /*#__PURE__*/React.createElement(MembershipPagesFunnel, null), /*#__PURE__*/React.createElement(ProfileFunnel, null), /*#__PURE__*/React.createElement(CancellationFunnel, null), /*#__PURE__*/React.createElement(ModificationLCFunnel, null), /*#__PURE__*/React.createElement(AlternativesFunnel, null));
App.propTypes = {
  flightResultsProps: PropTypes.object
};
export default App;